import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import { useTopicCategoryContext } from '../../../../contexts/TopicCategoryContext';

export default function CreateButton() {
  const { dispatch, actions, state } = useTopicCategoryContext();

  return (
    <div className="invite_search">
      <Row>
        <Col md={12} className="text-right">
          <Button
            onClick={() => actions.showCreateForm(dispatch)}
            bsStyle="primary"
          >
            Add Topic Category
          </Button>
        </Col>
      </Row>
    </div>
  );
}
